import React, {useState} from "react";
import {Box, Flex, Icon, useBreakpointValue} from "@chakra-ui/react";
import {ChevronUpIcon, ChevronDownIcon} from "@chakra-ui/icons";
import {CustomFilterIcon} from "../Inputs/Icons/Icons";
import {FilterModal} from "../Modals/FilterModal";
import {FieldType} from "../../common/constants";
import {FiChevronDown, FiChevronUp} from "react-icons/fi";
import {SortDirection} from "../../shared/entities/Order/Order";

interface FilterSortHeaderProps {
    headerText: string;
    filterName: string;
    onSortUpClick?: () => void;
    onSortDownClick?: () => void;
    onSortChange?: (val: any) => void;
    onFilterClick?: () => void;
    setFilterModalClose: () => void;
    setNewFilterValue: (val: any, modal: boolean) => void;
    isFilterActive: boolean;
    isFilterOpen: boolean;
    fieldType?: FieldType;
    options?: any;
    isSortingVisible?: boolean;  // флаг для видимости сортировки
    isFilterVisible?: boolean;   // флаг для видимости фильтра
}

const FilterSortHeader: React.FC<FilterSortHeaderProps> = ({
                                                               headerText,
                                                               filterName,
                                                               onSortChange,
                                                               onFilterClick,
                                                               setFilterModalClose,
                                                               isFilterActive,
                                                               isFilterOpen,
                                                               setNewFilterValue,
                                                               fieldType,
                                                               options,
                                                               isSortingVisible = false,  // по умолчанию сортировка видна
                                                               isFilterVisible = true   // по умолчанию фильтр виден
                                                           }) => {
    const [sortDirection, setSortDirection] = useState<SortDirection>('NO');
    const [buttonPosition, setButtonPosition] = useState({top: 0, left: 0});
    const isMobile = useBreakpointValue({base: true, sm: true, md: true, lg: false});

    const cycleSortDirection = () => {
        const nextDirection: SortDirection =
            sortDirection === 'NO' ? 'DESC' :
                sortDirection === 'DESC' ? 'ASC' :
                    'NO';

        setSortDirection(nextDirection);
        if (onSortChange) onSortChange({field: filterName, direction: nextDirection});
    };

    const handleImageClick = (event: React.MouseEvent<HTMLDivElement>) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setButtonPosition({top: rect.bottom, left: isMobile ? rect.left - 40 : rect.left});
        if (onFilterClick) onFilterClick();
    };

    const renderSortIcon = () => {
        if (sortDirection === "ASC") {
            return FiChevronUp;
        } else if (sortDirection === "DESC") {
            return FiChevronDown;
        }
        return FiChevronDown;
    };

    return (
        <Flex alignItems="center" w="100%" pl={1}>
            {/* Заголовок и фильтр (воронка) */}
            <Flex alignItems="center" gap="1">
                <Box userSelect="none">{headerText}</Box>
                {isFilterVisible && (
                    <Box onClick={handleImageClick} cursor="pointer">
                        <Icon
                            as={CustomFilterIcon}
                            w="14px"
                            h="14px"
                            style={{
                                filter: isFilterActive
                                    ? "invert(41%) sepia(60%) saturate(5366%) hue-rotate(207deg) brightness(91%) contrast(83%)"
                                    : "none"
                            }}
                        />
                    </Box>
                )}
            </Flex>

            {/* Иконка сортировки — справа */}
            {isSortingVisible && (
                <Box onClick={cycleSortDirection} cursor="pointer" ml="auto" pr={2}
                     color={sortDirection !== "NO" ? "blue.400" : "inherit"}>
                    {sortDirection !== "NO" ?
                        <Icon
                            as={renderSortIcon()}
                            w={"14px"}
                            h={"14px"}
                            strokeWidth={3}
                            verticalAlign="middle"
                        />
                        :
                        <Box lineHeight="1" display="flex" flexDir="column">
                            <ChevronUpIcon w="14px" h="12px"/>
                            <ChevronDownIcon w="14px" h="12px" mt="-4px"/>
                        </Box>
                    }
                </Box>
            )}

            <FilterModal
                isOpen={isFilterOpen}
                onClose={setFilterModalClose}
                buttonPosition={buttonPosition}
                setNewFilterValue={setNewFilterValue}
                uniqueName={filterName}
                fieldType={fieldType}
                options={options}
            />
        </Flex>
    );
};

export default FilterSortHeader;
